angular.module('app.player.timelineService', [

])
  .factory(
    'app.player.timelineService', [
      '$filter',
      ($filter) => {
        "use strict";

        let service = {
          columnHeaders: [
            {
              header_title: 'Clip Name',
              sorting_column: 'clip_name',
              class: 'clipName',
              selected: true
            },
            {
              header_title: 'Clip Time',
              sorting_column: 'clip_time',
              class: 'clipTime',
              selected: true
            },
           {
              header_title: 'Period',
              sorting_column: 'period',
              class: 'period',
              selected: false
            },
            {
              header_title: 'Clock Time',
              sorting_column: 'clock_time',
              class: 'clockTime',
              selected: false
            },
            {
              header_title: 'Category',
              sorting_column: 'category',
              class: 'clipCategory',
              selected: true
            },
            {
              header_title: 'Subcategory',
              sorting_column: 'subcategory',
              class: 'clipSubcategory',
              selected: false
            },
            {
              header_title: 'Strength',
              sorting_column: 'strength',
              class: 'clipStrength',
              selected: false
            },
            {
              header_title: 'Lines',
              sorting_column: 'lines',
              class: 'linesTable',
              subheaders: [
                {title:'LW', selected: true},
                {title:'RW', selected: true},
                {title:'C', selected: true},
                {title:'LD', selected: true},
                {title:'RD', selected: true},
                {title:'G', selected: true}
              ],
              selected: false
            },
            {
              header_title: 'Game Date',
              sorting_column: 'game_date',
              class: 'gameDate',
              selected: false
            },
            {
              header_title: 'Match-up',
              sorting_column: 'matchup',
              class: 'matchUp',
              selected: false
            },
            {
              header_title: 'Duration',
              sorting_column: 'duration',
              class: 'duration',
              selected: true
            }
          ],

          activeHeaders: {
            data: [],
            labels: []
          },

          table_width: 837,
          remainingWidth: 0,


          addRemoveHeader: (index) => {
            service.columnHeaders[index].selected = !service.columnHeaders[index].selected;

            let currentHeader = service.columnHeaders[index];
            service.columnHeaders.splice(index,1);

            if(!currentHeader.selected) {
              service.columnHeaders.push(currentHeader);
            } else {
              let no_header_selected = service.columnHeaders.every(function(header) {
                return !header.selected;
              });

              if (!no_header_selected) {
                for(let i = service.columnHeaders.length - 1; i >= 0 ; i--) {
                  if(service.columnHeaders[i].selected) {
                    service.columnHeaders.splice(i+1, 0, currentHeader);
                    break;
                  }
                }
              } else {
                service.columnHeaders.splice(0, 0, currentHeader);
              }
            }
          },

          assignSelectedHeaders: () => {
            service.activeHeaders['data'] = $filter('filter')(service.columnHeaders, {selected: true});
            service.activeHeaders['labels'] = [];

            _.forEach(service.activeHeaders['data'], (column) => {
              if(column.selected) {
                service.activeHeaders['labels'].push(column.sorting_column);
              }
            });
          },

          calcEmptyWidth: (element) => {
            let baseClass = '.video-analysis__my-clips__grid__cell--';
            let totalColumnWidth = 0;

            _.forEach(service.activeHeaders, (header) => {
              totalColumnWidth += $(baseClass+header.class).width();
            });

            service.table_width = $(element).clientWidth;

            service.remainingWidth =  service.table_width - totalColumnWidth;
          },

          emptySpaceExists: () => {
            return (0 < service.remainingWidth < service.table_width);
          },

          getEmptySpaceWidth: () => {
            return service.remainingWidth;
          },

          sortColumnHeaders: () => {
            return service.columnHeaders.sort((a, b) => {
              if (a.selected > b.selected) {
                return -1;
              }
              if (a.selected < b.selected) {
                return 1;
              }

              return 0;
            });
          }

        };

        return service;
      }
    ]
  );


// WEBPACK FOOTER //
// ./app.v2/components/player/timeline/timelineService.js